export interface SessionOverrides {
  subscriptionKey?: string;
}

export function getSessionOverrides(): SessionOverrides | null {
  const urlParams = new URLSearchParams(window.location.search);
  const sessionOverridesParam = urlParams.get('sessionOverrides');
  
  if (!sessionOverridesParam) {
    return null;
  }
  
  try {
    const parsed = JSON.parse(decodeURIComponent(sessionOverridesParam));
    return parsed as SessionOverrides;
  } catch (error) {
    console.warn('Failed to parse sessionOverrides query parameter:', error);
    return null;
  }
}
